import type { VModelEvents } from '../hooks/use-v-model';
import { createEmits } from '../utils/emits';

type RadioValue = string | number | boolean | undefined;

interface Events extends VModelEvents<RadioValue> {
  /** 选中值变化事件 */
  change: [value: RadioValue];
}

const {
  defineEmitType,
  useEmits,
} = createEmits<Events>();

export {
  useEmits,
};

export const emits = defineEmitType([
  'change',
  'input',
  'update:modelValue',
]);